module.exports = __webpack_public_path__ + "img/desaparecidos2.63b1594b.jpg";